import { MIXIN_PAGE_PUT_REQUEST } from '@/mixins/page/request/mixinPagePutRequest'

const MIXIN_PAGE_DETAIL = {
  mixins: [MIXIN_PAGE_PUT_REQUEST],
  data: () => ({
    isEdit: false
  }),
  methods: {
    toggleIsEdit () {
      this.isEdit = !this.isEdit
    },
    setIsEdit (bool) {
      this.isEdit = bool
    }
  }
}

export {
  MIXIN_PAGE_DETAIL
}
